export class Notification {
  id: number = 0;
  sharedId: number = 0;
  date: number = 0;
  month: number = 0;
  year: number = 0;
  day: number = 0;
  read: boolean = true;
  subject: string = '';
  message: string = '';
  notificationType: NotificationType = NotificationType.TRIGGER;
  waitingForResolve: boolean = false;
  parent: any;
  /**
   * @deprecated - use  firebaseParentId
   */
  parentId: number = -1;
  firebaseParentId: string = '';
}

export enum NotificationType {
  TRIGGER, DOWNTIME
}
